module.exports = __webpack_public_path__ + "static/media/possible4.72975597.webp";